export { default as PlanDetails } from './PlanDetails.container';
